import { ContactDrawer } from '@/components/contact-drawer';
import { ItemDrawer } from '@/components/item-drawer';
import { nameFor } from '@/lib/arabic';
import { useLanguage } from '@/lib/i18n';
import { closeNewDrawer, useNewDrawer } from '@/lib/new-drawer';

/** Quick-create drawers opened from "+ New" or a picker's "+ Add new", over any page. */
export function GlobalDrawers() {
  const req = useNewDrawer();
  const lang = useLanguage();
  const contactKind = req?.kind === 'customer' || req?.kind === 'vendor' ? req.kind : null;
  const onOpenChange = (open: boolean) => {
    if (!open) closeNewDrawer();
  };
  return (
    <>
      <ContactDrawer
        open={contactKind !== null}
        kind={contactKind ?? 'customer'}
        {...(req?.name ? { initialName: req.name } : {})}
        {...(req?.chooseKind ? { chooseKind: true } : {})}
        onOpenChange={onOpenChange}
        onSaved={(c) =>
          req?.onSaved?.({ id: c.id, label: nameFor(lang, c.displayName, c.displayNameAr) })
        }
      />
      <ItemDrawer
        open={req?.kind === 'item'}
        {...(req?.name ? { initialName: req.name } : {})}
        onOpenChange={onOpenChange}
        onSaved={(i) => req?.onSaved?.({ id: i.id, label: nameFor(lang, i.name, i.nameAr) })}
      />
    </>
  );
}
